import { useMutation } from '@tanstack/react-query';
import type { ErrorObject } from '../@types/api';
import { sendEmailVerification } from '../utils/api';

type ResendEmailPayload = { email: string; turnstileToken?: string };

export const useResendVerificationEmail = () =>
  useMutation<unknown, ErrorObject, ResendEmailPayload>({
    mutationFn: ({ email, turnstileToken }) => sendEmailVerification(email, turnstileToken),
  });
